import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  Paper,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip
} from "@mui/material";

import {
  collection,
  getDocs,
  doc,
  getDoc,
  setDoc,
} from "firebase/firestore";

import { db } from "../Config/firebase";
import Navbar from "../Components/Navbar/navbar";
import CabecalhoDetalhes from "../Components/CabecalhoDetalhes/CabecalhoDetalhes";
import { useParams, useHistory } from "react-router-dom";
import RelatorioRAAPrint from "./RelatorioRAAPrint";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PrintIcon from "@mui/icons-material/Print";
import SaveIcon from "@mui/icons-material/Save";
import VisibilityIcon from "@mui/icons-material/Visibility";


export default function LeiturasRAA() {

  const { ensaioId } = useParams();
  const [ensaio, setEnsaio] = useState(null);
  const [materiais, setMateriais] = useState({});
  const [linhas, setLinhas] = useState([]);
  const [modoImpressao, setModoImpressao] = useState(false);
  const history = useHistory();
  const [salvando, setSalvando] = useState(false);
  const [modoPrint, setModoPrint] = useState(false);
  const [autoPrint, setAutoPrint] = useState(false);
  const [mensagem, setMensagem] = useState("");
  const [temAlteracoes, setTemAlteracoes] = useState(false);
  const [openConfirmarCancelamento, setOpenConfirmarCancelamento] = useState(false);
  const [linhasOriginais, setLinhasOriginais] = useState([]);
  const [navegacaoPendente, setNavegacaoPendente] = useState(null);
  const desbloquearNavegacaoRef = useRef(null);

  function clonarLinhas(lista) {
    return JSON.parse(JSON.stringify(lista || []));
  }

  function impedirAlteracaoNumeroNoScroll(event) {
    event.target?.blur?.();
  }

        useEffect(() => {
        if (!ensaioId) return;
        carregarEnsaio();
      }, [ensaioId]);

      useEffect(() => {
        function confirmarSaida(event) {
          if (!temAlteracoes) return;

          event.preventDefault();
          event.returnValue = "";
        }

        window.addEventListener("beforeunload", confirmarSaida);
        return () => window.removeEventListener("beforeunload", confirmarSaida);
      }, [temAlteracoes]);

      useEffect(() => {
        if (!temAlteracoes) return undefined;

        desbloquearNavegacaoRef.current = history.block((location) => {
          setNavegacaoPendente(location);
          setOpenConfirmarCancelamento(true);
          return false;
        });

        return () => {
          desbloquearNavegacaoRef.current?.();
          desbloquearNavegacaoRef.current = null;
        };
      }, [history, temAlteracoes]);

      function gerarDatasLeitura(dataMoldagem) {

          if (!dataMoldagem) return [];

          const [ano, mes, dia] = dataMoldagem.split("-");
          const dataBase = new Date(ano, mes - 1, dia);
          const leituraInicial = adicionarDias(dataBase, 1);
          const leituraDezesseisDias = adicionarDias(leituraInicial, 16);
          const leiturasAntes = proximasSegundasEQuintas(leituraInicial, 4, {
            antesDe: leituraDezesseisDias,
          });
          const leiturasDepois = proximasSegundasEQuintas(leituraDezesseisDias, 4);

          return [
            ...leiturasAntes,
            leituraDezesseisDias,
            ...leiturasDepois,
          ].map(formatarDataISO);
        }

      function adicionarDias(data, dias) {
        const d = new Date(data);
        d.setDate(d.getDate() + dias);
        return d;
      }

      function formatarDataISO(data) {
        const yyyy = data.getFullYear();
        const mm = String(data.getMonth() + 1).padStart(2, "0");
        const dd = String(data.getDate()).padStart(2, "0");
        return `${yyyy}-${mm}-${dd}`;
      }

      function proximasSegundasEQuintas(dataReferencia, quantidade, opcoes = {}) {
        const datas = [];
        const cursor = adicionarDias(dataReferencia, 1);
        const limite = opcoes.antesDe ? new Date(opcoes.antesDe) : null;

        while (datas.length < quantidade) {
          const diaSemana = cursor.getDay();
          const dataCandidata = new Date(cursor);

          if (limite && dataCandidata >= limite) break;

          if (diaSemana === 1 || diaSemana === 4) {
            datas.push(dataCandidata);
          }

          cursor.setDate(cursor.getDate() + 1);
        }

        return datas;
      }

      function leituraTemDadosPreenchidos(leitura) {
        if (!leitura) return false;

        if (leitura.temperatura || leitura.barraPadrao || leitura.media) return true;

        return (leitura.barras || []).some((barra) =>
          barra?.micrometro || barra?.comprimento || barra?.expansao
        );
      }


  async function carregarEnsaio() {

  const snap = await getDoc(doc(db, "tblEnsaioRAA", ensaioId));
  if (!snap.exists()) return;

  const dados = snap.data();
  const mapaMateriais = {};

if (dados.agregadoId) {
  const snapAgregado = await getDoc(
    doc(db, "tblListaMateriaisCadastrados", dados.agregadoId)
  );
  if (snapAgregado.exists()) mapaMateriais.agregado = snapAgregado.data();
}

if (dados.cimentoId) {
  const snapCimento = await getDoc(
    doc(db, "tblListaMateriaisCadastrados", dados.cimentoId)
  );
  if (snapCimento.exists()) mapaMateriais.cimento = snapCimento.data();
}

if (dados.adicaoId) {
  const snapAdicao = await getDoc(
    doc(db, "tblListaMateriaisCadastrados", dados.adicaoId)
  );
  if (snapAdicao.exists()) mapaMateriais.adicao = snapAdicao.data();
}

setMateriais(mapaMateriais);

  const barrasSalvas = Array.isArray(dados.barras)
    ? dados.barras
    : [];

  setEnsaio({ ...dados, docId: snap.id });

  // Base fixa com 9 linhas
  const datasSugeridas = gerarDatasLeitura(dados.dataMoldagem);

      // Base fixa com 9 linhas
      const base = Array.from({ length: 9 }, (_, index) => ({
        ordem: index,
        data: datasSugeridas[index] || "",
    temperatura: "",
    barraPadrao: "",
    barras: barrasSalvas.map(b => ({
      numero: b.numero || "",
      micrometro: "",
      comprimento: "",
      expansao: ""
    })),
    media: ""
  }));

  // Buscar leituras já salvas
  
         const leiturasSnap = await getDocs(
  collection(db, "tblEnsaioRAA", ensaioId, "leituras")
);

const leiturasDocs = leiturasSnap.docs;
const total = leiturasDocs.length;

for (let i = 0; i < total; i++) {

  const leitura = leiturasDocs[i].data();



          if (leitura.data && leitura.data.includes("/")) {
            const [dia, mes, ano] = leitura.data.split("/");
            leitura.data = `${ano}-${mes.padStart(2, "0")}-${dia.padStart(2, "0")}`;
          }


        const index = Number(leiturasDocs[i].id);

        if (!isNaN(index) && index < 9) {

          base[index] = {
            ...base[index],
            ...leitura,
            data: leituraTemDadosPreenchidos(leitura)
              ? leitura.data
              : base[index].data
          };
        }

     
  }

  setLinhas([...base]);
  setLinhasOriginais(clonarLinhas(base));
  setTemAlteracoes(false);
  setOpenConfirmarCancelamento(false);
}
  

  function atualizarCampo(linhaIndex, campo, valor) {
    setMensagem("");
    setTemAlteracoes(true);
  setLinhas(prev =>
    prev.map((linha, i) =>
      i === linhaIndex
        ? { ...linha, [campo]: valor }
        : linha
    )
  );
}

  function atualizarBarra(linhaIndex, barraIndex, campo, valor) {
    setMensagem("");
    setTemAlteracoes(true);
  setLinhas(prev =>
    prev.map((linha, i) => {
      if (i !== linhaIndex) return linha;

      const novasBarras = linha.barras.map((barra, j) =>
        j === barraIndex
          ? { ...barra, [campo]: valor }
          : barra
      );

      return { ...linha, barras: novasBarras };
    })
  );
}

  function calcularLinha(index) {

  setLinhas(prev => {

    const linha = prev[index];

    if (!linha.barraPadrao || Number(linha.barraPadrao) <= 0) {
      return prev;
    }

    let soma = 0;
    let contador = 0;

    const novasBarras = linha.barras.map((barra, i) => {

      if (!barra.micrometro) {
            return {
              ...barra,
              comprimento: "",
              expansao: ""
            };
          }

      const L0 =
        Number(ensaio?.barraPadraoInicial || 0) +
        Number(ensaio?.barras?.[i]?.micrometroInicial || 0);

      const Lt =
        Number(linha.barraPadrao) +
        Number(barra.micrometro);

      const expansao = ((Lt - L0) / L0) * 100;

      soma += expansao;
      contador++;

      return {
        ...barra,
        comprimento: Lt.toFixed(3),
        expansao: expansao.toFixed(2)
      };
    });

    const novaLinha = {
      ...linha,
      barras: novasBarras,
      media: contador > 0 ? (soma / contador).toFixed(2) : ""
    };

    return prev.map((l, i) =>
      i === index ? novaLinha : l
    );
  });
}
      async function salvarTudo() {

        try {
          setSalvando(true);
          setMensagem("");

          const linhasComData = linhas.filter(l => l.data);

          if (linhasComData.length === 0) {
            setMensagem("Informe pelo menos uma data antes de salvar.");
            setSalvando(false);
            return;
          }

          const promessas = new Array(linhas.length);

          for (let i = 0; i < linhas.length; i++) {

            const linha = linhas[i];

            if (!linha.data) continue;

            promessas[i] = setDoc(
              doc(db, "tblEnsaioRAA", ensaioId, "leituras", String(i)),
              {
                ...linha,
                ordem: i
              }
            );
          }

          await Promise.all(promessas.filter(Boolean));

          const leiturasValidas = linhas.filter(l => l.media);

          const ultimaLeitura =
            leiturasValidas.length > 0
              ? leiturasValidas[leiturasValidas.length - 1]
              : null;

          await setDoc(
            doc(db, "tblEnsaioRAA", ensaioId),
            {
              qtdLeituras: leiturasValidas.length,
              ultimaExp: ultimaLeitura?.media || null
            },
            { merge: true }
          );

          setMensagem("Salvo com sucesso!");
          setLinhasOriginais(clonarLinhas(linhas));
          setTemAlteracoes(false);
          desbloquearNavegacaoRef.current?.();
          desbloquearNavegacaoRef.current = null;
          history.push("/app/ensaio-raa");

        } catch (error) {
          console.error("Erro ao salvar:", error);
          setMensagem("Erro ao salvar dados.");
        } finally {
          setSalvando(false);
        }
      }

function visualizar() {
  setAutoPrint(false);
  setModoPrint(true);
}

function imprimir() {
  setAutoPrint(true);
  setModoPrint(true);
}

      function voltar() {
        history.goBack();
      }

function solicitarCancelarAlteracoes() {
  setNavegacaoPendente(null);
  setOpenConfirmarCancelamento(true);
}

function confirmarCancelarAlteracoes() {
  setLinhas(clonarLinhas(linhasOriginais));
  setTemAlteracoes(false);
  setMensagem("");
  setOpenConfirmarCancelamento(false);

  if (navegacaoPendente) {
    const destino = `${navegacaoPendente.pathname}${navegacaoPendente.search || ""}${navegacaoPendente.hash || ""}`;
    desbloquearNavegacaoRef.current?.();
    desbloquearNavegacaoRef.current = null;
    setNavegacaoPendente(null);
    history.push(destino);
  }
}
  

  if (!ensaio || !materiais) return null;

if (modoPrint) {
  return (
    <RelatorioRAAPrint
      ensaio={ensaio}
      leituras={linhas.map((l, i) => ({
        id: i,
        dataLeitura: l.data,
        barra106: { expansao: l.barras[0]?.expansao },
        barra107: { expansao: l.barras[1]?.expansao },
        barra108: { expansao: l.barras[2]?.expansao },
        expansaoMedia: l.media !== "" 
          ? Number(String(l.media).replace(",", "."))
          : null
      }))}
      autoPrint={autoPrint}
      onVoltar={() => {
        setModoPrint(false);
        setAutoPrint(false);
      }}
    />
  );
}
  function formatarDataBR(data) {
  if (!data) return "-";

  // Timestamp Firestore
  if (data?.seconds) {
    const d = new Date(data.seconds * 1000);
    return d.toLocaleDateString("pt-BR");
  }

  // String yyyy-mm-dd
  if (typeof data === "string" && data.includes("-")) {
    const [ano, mes, dia] = data.split("-");
    return `${dia}/${mes}/${ano}`;
  }

  return data;
}

  return (
  <>
    <Navbar />

        <CabecalhoDetalhes
          titulo="Ensaio de Reação Álcali Agregado"
          subtitulo="RQ 2.2.4-A   Rev.00 - 20/08/2025"
        >
          <Tooltip title="Visualizar relatório">
            <span>
              <IconButton color="primary" onClick={visualizar} disabled={temAlteracoes || salvando}>
                <VisibilityIcon />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title="Imprimir relatório">
            <span>
              <IconButton color="primary" onClick={imprimir} disabled={temAlteracoes || salvando}>
                <PrintIcon />
              </IconButton>
            </span>
          </Tooltip>
          {temAlteracoes ? (
            <>
              <Button variant="contained" onClick={salvarTudo} disabled={salvando} startIcon={<SaveIcon />}>
                {salvando ? "Salvando..." : "Salvar"}
              </Button>
              <Button data-confirmacao-cancelamento="propria" variant="outlined" onClick={solicitarCancelarAlteracoes} disabled={salvando}>
                Cancelar alterações
              </Button>
            </>
          ) : (
            <Button variant="outlined" onClick={voltar} disabled={salvando} startIcon={<ArrowBackIcon />}>
              Voltar
            </Button>
          )}
        </CabecalhoDetalhes>

        <Box sx={{ p: 4 }} component="form" autoComplete="off">


      {/* ================= BLOCO 2 - DADOS DO ENSAIO ================= */}
      <Paper sx={{ p: 2, mb: 3 }}>

        <Typography fontWeight={700} mb={2}>
          DADOS DO ENSAIO
        </Typography>

        <Box
            display="grid"
            gridTemplateColumns="repeat(4, 1fr)"
            gap={2}
          >

            {/* LINHA 1 */}
            <TextField
              label="Data Cadastro"
              value={formatarDataBR(ensaio?.criadoEm)}
              size="small"
              InputProps={{ readOnly: true }}
            />

            <TextField
              label="Cliente"
              value={ensaio?.cliente || "-"}
              size="small"
              InputProps={{ readOnly: true }}
            />

            <TextField
                label="Fornecedor"
                value={ensaio?.fornecedor || "-"}
                size="small"
                InputProps={{ readOnly: true }}
              />

            <TextField
              label="Cód."
              value={ensaio?.codigo || "-"}
              size="small"
              InputProps={{ readOnly: true }}
            />

            {/* LINHA 2 */}
            <TextField
              label="Agregado"
              value={materiais?.agregado?.Descricao || "-"}
              size="small"
              InputProps={{ readOnly: true }}
            />

            <TextField
              label="Cimento"
              value={materiais?.cimento?.Descricao || "-"}
              size="small"
              InputProps={{ readOnly: true }}
            />

            <Box display="flex" gap={2}>
                  <TextField
                    label="Adição"
                    value={materiais?.adicao?.Descricao || "-"}
                    size="small"
                    InputProps={{ readOnly: true }}
                    fullWidth
                  />

                  {ensaio?.adicaoId && (
                    <TextField
                      label="% Adição"
                      value={ensaio?.percentualAdicao || "-"}
                      size="small"
                      InputProps={{ readOnly: true }}
                      sx={{ maxWidth: 120 }}
                    />
                  )}
                </Box>

            <TextField
              label="Data Moldagem"
              value={formatarDataBR(ensaio?.dataMoldagem)}
              size="small"
              InputProps={{ readOnly: true }}
            />

          </Box>

      </Paper>


      {/* ================= BLOCO 3 - LEITURA INICIAL ================= */}
      <Paper sx={{ p: 2, mb: 3 }}>

        <Typography fontWeight={700} mb={2}>
          LEITURA INICIAL - FORA DA SOLUÇÃO ÁCIDA
        </Typography>

        <Table size="small">

          <TableHead>
            <TableRow>
              <TableCell>DATA</TableCell>

              {ensaio?.barras?.map((b, i) => (
                <React.Fragment key={i}>
                  <TableCell>LEIT. MICROM (mm)</TableCell>
                  <TableCell>BARRA (mm)</TableCell>
                </React.Fragment>
              ))}

              <TableCell>TEMP °C</TableCell>
              <TableCell>BARRA PADRÃO</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            <TableRow>

              <TableCell>
                  {(() => {
                    if (!ensaio?.dataMoldagem) return "-";

                    const [ano, mes, dia] = ensaio.dataMoldagem.split("-");
                    const d = new Date(ano, mes - 1, dia);

                    d.setDate(d.getDate() + 1);

                    return d.toLocaleDateString("pt-BR");
                  })()}
                </TableCell>

              {ensaio?.barras?.map((b, i) => {

                const comprimento =
                  Number(ensaio?.barraPadraoInicial || 0) +
                  Number(b.micrometroInicial || 0);

                return (
                  <React.Fragment key={i}>
                    <TableCell>{b.micrometroInicial}</TableCell>
                    <TableCell>{comprimento.toFixed(3)}</TableCell>
                  </React.Fragment>
                );
              })}

              <TableCell>{ensaio?.temperaturaInicial}</TableCell>
              <TableCell>{ensaio?.barraPadraoInicial}</TableCell>

            </TableRow>
          </TableBody>

        </Table>

      </Paper>


      {/* ================= BLOCO 4 - LEITURAS NA SOLUÇÃO ÁCIDA ================= */}
      <Paper sx={{ p: 2 }}>

        <Typography fontWeight={700} mb={2}>
          LEITURA - NA SOLUÇÃO ÁCIDA
        </Typography>

        <Table size="small">

          <TableHead>
            <TableRow>
              <TableCell>DATA</TableCell>

              {ensaio?.barras?.map((b, i) => (
                <React.Fragment key={i}>
                  <TableCell>LEIT. MICROM (mm)</TableCell>
                  <TableCell>BARRA (mm)</TableCell>
                  <TableCell>EXP (%)</TableCell>
                </React.Fragment>
              ))}

              <TableCell>EXP MÉDIA (%)</TableCell>
              <TableCell>TEMP AMB °C</TableCell>
              <TableCell>BARRA PADRÃO</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>

            {linhas.map((linha, linhaIndex) => (
              <TableRow key={linhaIndex}>

                {modoImpressao ? (
                      <TableCell>{formatarDataBR(linha.data)}</TableCell>
                    ) : (
                      <TableCell>
                        <TextField
                                  type="date"
                                  size="small"
                                  value={
                                    linha.data && linha.data.includes("-") && linha.data.length === 10
                                      ? linha.data
                                      : ""
                                  }
                                  onChange={(e) =>
                                    atualizarCampo(linhaIndex, "data", e.target.value)
                                  }
                                />
                      </TableCell>
                    )}

                {linha.barras.map((barra, barraIndex) => (
                  <React.Fragment key={barraIndex}>

                    <TableCell>
                      <TextField
                        size="small"
                        type="number"
                        value={barra.micrometro}
                        onWheel={impedirAlteracaoNumeroNoScroll}
                        onChange={(e) => {
                            atualizarBarra(
                              linhaIndex,
                              barraIndex,
                              "micrometro",
                              e.target.value
                            );

                            // Recalcula automaticamente ao apagar/digitar
                            setTimeout(() => calcularLinha(linhaIndex), 0);
                          }}
                        onBlur={() => {
                          if (linha.barraPadrao && linha.barras.some(b => b.micrometro)) {
                            calcularLinha(linhaIndex);
                          }
                        }}
                      />
                    </TableCell>

                    <TableCell>{barra.comprimento}</TableCell>

                    <TableCell>{barra.expansao}</TableCell>

                  </React.Fragment>
                ))}

                <TableCell>{linha.media}</TableCell>

                <TableCell>
                  <TextField
                    size="small"
                    type="number"
                    value={linha.temperatura}
                    onWheel={impedirAlteracaoNumeroNoScroll}
                    onChange={(e) =>
                      atualizarCampo(
                        linhaIndex,
                        "temperatura",
                        e.target.value
                      )
                    }
                  />
                </TableCell>

                <TableCell>
                  <TextField
                    size="small"
                    type="number"
                    value={linha.barraPadrao}
                    onWheel={impedirAlteracaoNumeroNoScroll}
                    onChange={(e) =>
                      atualizarCampo(
                        linhaIndex,
                        "barraPadrao",
                        e.target.value
                      )
                    }
                    onBlur={() => calcularLinha(linhaIndex)}
                  />
                </TableCell>

              </TableRow>
            ))}

          </TableBody>

        </Table>

            </Paper>
      {mensagem && (
        <Typography
          color={mensagem.includes("sucesso") ? "success.main" : "error"}
          sx={{ mb: 2 }}
        >
          {mensagem}
        </Typography>
      )}
      {/* ================= BOTÕES ================= */}
      <Dialog
        open={openConfirmarCancelamento}
        onClose={() => setOpenConfirmarCancelamento(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Cancelar alterações</DialogTitle>
        <DialogContent dividers>
          <Typography>
            Todos os dados alterados serão perdidos. Deseja continuar?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setNavegacaoPendente(null);
            setOpenConfirmarCancelamento(false);
          }}>
            Não
          </Button>
          <Button color="error" variant="contained" onClick={confirmarCancelarAlteracoes}>
            Sim, cancelar
          </Button>
        </DialogActions>
      </Dialog>
</Box>
  </>
);
}



